module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.years), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "link",
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n            " + _vm._s(item.jahr) + "\r\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\r\n        Aktueller Vergleich: " + _vm._s(_vm.period == 'vormonat' || _vm.period == '' ? 'Periode' : 'Ganzes Jahr') + "\r\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11830738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/Years.html
// module id = 552
// module chunks = 1